import {fetchApi} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'
import * as types from './types'

export default () => dispatch => {
    dispatch({type: types.GET_WEATHER_TYPES_START})
    dispatch(resetError())
    return fetchApi('/api/fb/weather/types')
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_WEATHER_TYPES_SUCCESS, response: response
            })
        }).catch(error => {
            dispatch({
                type: types.GET_WEATHER_TYPES_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading weather types.'}))
        })
}

export const handler_GET_WEATHER_TYPES_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoadingTypes: true,
        types: undefined
    })
}

export const handler_GET_WEATHER_TYPES_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoadingTypes: false,
        types: action.response.Descriptions || []
    })
}

export const handler_GET_WEATHER_TYPES_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoadingTypes: false,
        types: undefined
    })
}

actionMap[types.GET_WEATHER_TYPES_START] = handler_GET_WEATHER_TYPES_START
actionMap[types.GET_WEATHER_TYPES_SUCCESS] = handler_GET_WEATHER_TYPES_SUCCESS
actionMap[types.GET_WEATHER_TYPES_FAILURE] = handler_GET_WEATHER_TYPES_FAILURE


// WEBPACK FOOTER //
// ./src/screens/weather/actions/getWeatherTypes.js